import { render, staticRenderFns } from "./PortHeader.vue?vue&type=template&id=f244083a&scoped=true"
import script from "./PortHeader.vue?vue&type=script&lang=js"
export * from "./PortHeader.vue?vue&type=script&lang=js"
import style0 from "./PortHeader.vue?vue&type=style&index=0&id=f244083a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f244083a",
  null
  
)

export default component.exports